import { Dispatch, SetStateAction } from "react"

export interface ProductDetails {
  name: string,
  description?: string,
  price: number,
  images: Array<string>,
  categories: Array<string>
}

export interface ProductModalDetails extends ProductDetails {
  setModalIsOpen: Dispatch<SetStateAction<boolean>>,
  show: boolean
}

export interface CartItemProps extends ProductDetails {
  quantity: number
}

export interface CartModalDetails {
  cart: CartItemProps[],
  setModalIsOpen: Dispatch<SetStateAction<boolean>>,
  show: boolean
}

export interface ProductProps extends ProductDetails {
  setModalIsOpen: Dispatch<SetStateAction<boolean>>,
  setModalData: Dispatch<SetStateAction<ProductDetails>>
}

export type CartDetails = { [key: string]: number }

export interface Filters {
  minimumPrice: string;
  maximumPrice: string;
  categories: { [key: string]: boolean };
}

export const SORT_OPTIONS = [
  'Default',
  'Price: Low to High',
  'Price: High to Low',
  'Product name: A to Z',
  'Product name: Z to A',
] as const;

export type Sort = (typeof SORT_OPTIONS)[number];

export interface ContextProviderValue {
  cartItems: CartDetails, 
  products: ProductDetails[], 
  isLoading: boolean,
  productsError: string | null,
  addToCart: (...args: any[]) => any, 
  removeFromCart: (...args: any[]) => any
  setCartQuantity: (...args: any[]) => any,
  clearCart: () => void,
}